const perPageOptions = [12, 24, 48];
export {
  perPageOptions
};
